import { isObject, matches, pick } from 'lodash';
import { ApolloLink } from '@apollo/client';
import type { FetchResult } from '@apollo/client/link/core';
import type { ValidationMessage } from '../../generated';

type MutationErrorMessages = Array<ValidationMessage>;
type MutationErrorResponse = {
  data: {
    successful: boolean;
    result: null;
    messages: MutationErrorMessages;
  };
} & FetchResult;

function throwMutationError(messages: MutationErrorMessages) {
  function formatError(message: ValidationMessage) {
    return pick(message, ['message', 'code', 'field']);
  }

  const [leading, ...rest] = messages.map(formatError);

  throw messages.length > 1 ? [leading, ...rest] : leading;
}

const maybeThrowMutationError = (response: MutationErrorResponse) => {
  if (isObject(response?.data)) {
    Object.values(response.data).forEach((data) => {
      const isValidationError = data?.successful === false;

      if (isValidationError) {
        throwMutationError(data.messages);
      }
    });
  }

  return response;
};

const containsMutations = matches({ operation: 'mutation' });

export default new ApolloLink((operation, forward) => {
  if (operation.query.definitions.some(containsMutations)) {
    return forward(operation).map(maybeThrowMutationError);
  }

  return forward(operation);
});
